<template>
    <div :style="{height: height+'px'}">
        <div class="status-bar" :style="{height: height+'px', backgroundColor: backgroundColor}"></div>
    </div>
</template>
<script>
import { bindAppFn } from '../../utils'
export default {
    name: 'vipCoacpStatusBar',
    props: {
        backgroundColor: {
            type: String,
            default: 'transparent'
        }
    },
    data () {
        return {
            height: ''
        }
    },
    mounted () {
        // 获取app的高度 设置状态栏
        bindAppFn({
            name: 'app',
            data: {
                method: 'getStateBarHeight'
            },
            currentFnName: 'getCoachAppStateBarHeight',
            callback: (e) => {
                this.height = e || 0
                this.$emit('getHeight', this.height)
            }
        })
    }
}
</script>
<style lang="scss" scoped>
.status-bar{
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 9;
}
</style>
